<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#deliveryNotePanel' }"
    [visible]="isExporting"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
>
</dx-load-panel>
<div #deliveryNotePanel class="main dx-card padding-content">
    <dx-box direction="row" crossAlign="center">
        <dxi-item [ratio]="4">
            <div style="text-align: start">
                <dx-button
                    [disabled]="isExporting || !messageSourceWindow"
                    stylingMode="outlined"
                    icon="download"
                    type="normal"
                    text="Load Lnwshop Data"
                    (onClick)="requestMessage()"
                ></dx-button>
            </div>
        </dxi-item>
        <dxi-item [ratio]="9" style="text-align: center">
            <span style="font-size: x-large">ใบส่งของชั่วคราว</span>
        </dxi-item>
        <dxi-item [ratio]="3" style="padding-right: 10px; text-align: right">
            <dx-button
                [disabled]="isExporting"
                stylingMode="outlined"
                text="Clear"
                icon="clear"
                type="danger"
                width="60%"
                (onClick)="clearForm()"
            ></dx-button
        ></dxi-item>
        <dxi-item [ratio]="3" style="padding-right: 10px">
            <dx-button
                [disabled]="isExporting"
                stylingMode="contained"
                text="Preview PDF"
                icon="pdffile"
                type="normal"
                width="100%"
                (onClick)="exportPdf()"
            ></dx-button>
        </dxi-item>
        <dxi-item [ratio]="3">
            <dx-button
                [disabled]="isExporting"
                stylingMode="contained"
                text="Save / Share"
                icon="save"
                type="default"
                width="100%"
                (onClick)="saveAndShare()"
            ></dx-button>
        </dxi-item>
    </dx-box>
    @if (shareData) {
    <dx-box direction="row" crossAlign="center" style="margin-top: 10px">
        <dxi-item [ratio]="1" style="padding-right: 10px">
            <dx-text-box
                width="100%"
                label="File Name"
                [value]="shareData.fileName"
                style="margin-bottom: 7px"
            >
            </dx-text-box>
        </dxi-item>
        <dxi-item [ratio]="9" style="padding-right: 10px">
            <dx-text-box
                width="100%"
                label="Shared URL"
                [value]="shareData.sharedUrl"
                style="margin-bottom: 7px"
            ></dx-text-box>
        </dxi-item>
        <dxi-item [ratio]="1" style="padding-right: 10px">
            <dx-button
                [disabled]="isExporting"
                stylingMode="contained"
                text="Copy"
                icon="copy"
                width="100%"
                (onClick)="copySharedUrlToClipboard()"
            ></dx-button>
        </dxi-item>
        <dxi-item [ratio]="1">
            <dx-button
                [disabled]="isExporting"
                stylingMode="contained"
                text="Open"
                icon="link"
                width="100%"
                (onClick)="openSharedUrl()"
            ></dx-button>
        </dxi-item>
    </dx-box>
    }

    <div class="section-header" style="margin-top: 10px">ข้อมูลเอกสาร</div>
    <div class="flex-container-row">
        <div style="flex-basis: 30%">
            <dx-select-box
                [(value)]="inputValues.docInfo.entityId"
                [items]="sellerEntities"
                displayExpr="legalName"
                valueExpr="id"
                placeholder="เลือกผู้ขาย"
                [showClearButton]="true"
                label="ผู้ขาย"
                labelMode="floating"
                (onValueChanged)="onInputsUpdated()"
            ></dx-select-box>
        </div>
        <div style="flex-basis: 30%">
            <dx-text-box
                [(value)]="inputValues.docInfo.invNum"
                [showClearButton]="true"
                labelMode="floating"
                label="เลขที่เอกสาร (เช่น TDN2026-001)"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div style="flex-basis: 20%">
            <dx-date-box
                label="วันที่"
                labelMode="floating"
                displayFormat="dd MMMM yyyy"
                dateSerializationFormat="yyyy-MM-dd"
                [showClearButton]="true"
                [(value)]="inputValues.docInfo.date"
                (onValueChanged)="onInputsUpdated()"
                [calendarOptions]="{ showTodayButton: true }"
            >
            </dx-date-box>
        </div>
        <div style="flex-basis: 20%">
            <dx-text-box
                [(value)]="inputValues.docInfo.refNo"
                [showClearButton]="true"
                labelMode="floating"
                label="อ้างอิง (Ref.#)"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
    </div>

    <div class="section-header">ข้อมูลผู้ซื้อ</div>
    <div class="flex-container-row">
        <div style="flex-grow: 5">
            <dx-text-box
                [(value)]="inputValues.customerInfo.name"
                [showClearButton]="true"
                labelMode="floating"
                label="ชื่อ"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div style="flex-grow: 1">
            <dx-text-box
                [(value)]="inputValues.customerInfo.taxId"
                [showClearButton]="true"
                labelMode="floating"
                label="เลขประจำตัวผู้เสียภาษี"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div style="flex-grow: 1">
            <dx-select-box
                [(value)]="inputValues.customerInfo.branch"
                [items]="branchList"
                placeholder="เลือกสาขา"
                [showClearButton]="true"
                label="สาขา"
                labelMode="floating"
                [acceptCustomValue]="true"
                (onValueChanged)="onInputsUpdated()"
            ></dx-select-box>
        </div>
    </div>

    <div class="section-header">
        <span>ที่อยู่</span>
    </div>

    <div class="checkbox-container" style="margin: 10px; margin-left: 20px">
        <dx-switch
            [(value)]="inputValues.customerInfo.useCustomAddress"
            (onValueChanged)="onInputsUpdated()"
        >
        </dx-switch>
        &nbsp;
        <span
            [ngClass]="{
                'user-input': inputValues.customerInfo.useCustomAddress
            }"
            >กรอกที่อยู่เอง</span
        >
    </div>

    @if (!inputValues.customerInfo.useCustomAddress) {
    <div class="flex-container-row" style="align-items: center">
        <div>
            <dx-autocomplete
                placeholder="พิมพ์รหัสไปรษณีย์ ..."
                [showClearButton]="true"
                [(value)]="inputValues.customerInfo.postCode"
                labelMode="floating"
                label="รหัสไปรษณีย์"
                [dataSource]="postCodeSuggestions"
                [minSearchLength]="2"
                [showDropDownButton]="true"
                searchMode="startswith"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-autocomplete>
        </div>
        →
        <div>
            <dx-select-box
                [(value)]="inputValues.customerInfo.province"
                placeholder="เลือกจังหวัด"
                [showClearButton]="true"
                label="จังหวัด"
                labelMode="floating"
                [searchEnabled]="true"
                [acceptCustomValue]="true"
                [items]="provinceSuggestions"
                (onValueChanged)="onInputsUpdated()"
            ></dx-select-box>
        </div>
        →
        <div>
            <dx-select-box
                [(value)]="inputValues.customerInfo.district"
                placeholder="เลือกเขต/อำเภอ"
                [showClearButton]="true"
                label="เขต/อำเภอ"
                labelMode="floating"
                [searchEnabled]="true"
                [acceptCustomValue]="true"
                [items]="districtSuggestions"
                (onValueChanged)="onInputsUpdated()"
            ></dx-select-box>
        </div>
        →
        <div>
            <dx-select-box
                [(value)]="inputValues.customerInfo.subDistrict"
                placeholder="เลือกแขวง/ตำบล"
                [showClearButton]="true"
                label="แขวง/ตำบล"
                labelMode="floating"
                [searchEnabled]="true"
                [acceptCustomValue]="true"
                [items]="subDistrictSuggestions"
                (onValueChanged)="onInputsUpdated()"
            ></dx-select-box>
        </div>
    </div>
    } @if (!inputValues.customerInfo.useCustomAddress) {
    <div class="flex-container-row">
        <div>
            <dx-text-box
                [(value)]="inputValues.customerInfo.address1"
                [showClearButton]="true"
                labelMode="floating"
                label="บ้านเลขที่ ซอย ถนน"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
    </div>
    } @if (!inputValues.customerInfo.useCustomAddress) {
    <div class="flex-container-row">
        <div>
            <dx-text-area
                [(value)]="inputValues.customerInfo.fullAddress"
                [height]="60"
                labelMode="floating"
                label="ที่อยู่เต็ม"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-area>
        </div>
    </div>
    } @if (inputValues.customerInfo.useCustomAddress) {
    <div class="flex-container-row">
        <div>
            <dx-text-area
                [(value)]="inputValues.customerInfo.customAddress"
                [height]="90"
                labelMode="floating"
                placeholder="กรอกที่อยู่กำหนดเอง"
                label="ที่อยู่กำหนดเอง"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-area>
        </div>
    </div>
    }

    <div class="section-header">อื่นๆ</div>
    <div class="flex-container-row">
        <div>
            <dx-text-area
                [(value)]="inputValues.docInfo.remark"
                [height]="60"
                labelMode="floating"
                label="หมายเหตุ"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-area>
        </div>
    </div>
    <div class="flex-container-row" style="margin-top: 10px">
        <div class="checkbox-container">
            <dx-switch
                [(value)]="inputValues.docInfo.hideSignatureFields"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-switch>
            &nbsp;<span
                [ngClass]="{
                    'user-input': inputValues.docInfo.hideSignatureFields
                }"
                >ซ่อนช่องลายเซ็น</span
            >
        </div>
        <div
            class="checkbox-container"
            [style.visibility]="
                inputValues.docInfo.hideSignatureFields ? 'hidden' : 'visible'
            "
        >
            <dx-switch
                [(value)]="inputValues.docInfo.isSigned"
                (onValueChanged)="onInputsUpdated()"
                [style.visibility]="
                    inputValues.docInfo.hideSignatureFields
                        ? 'hidden'
                        : 'visible'
                "
            >
            </dx-switch>
            &nbsp;<span
                [style.visibility]="
                    inputValues.docInfo.hideSignatureFields
                        ? 'hidden'
                        : 'visible'
                "
                [ngClass]="{
                    'user-input': inputValues.docInfo.isSigned
                }"
                >เซ็นเอกสาร</span
            >
        </div>
        <div>
            <dx-text-box
                [(value)]="inputValues.docInfo.customTitle"
                [showClearButton]="true"
                labelMode="floating"
                label="เปลี่ยนหัวเอกสาร"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
    </div>

    <div class="section-header">รายการสินค้า</div>
    <div class="flex-container-row" style="margin-bottom: 10px">
        <dx-data-grid
            #dataGrid
            class="dx-card"
            style="padding-top: 10px"
            keyExpr="itemNo"
            [showBorders]="false"
            [columnAutoWidth]="false"
            [allowColumnResizing]="true"
            [dataSource]="inputValues.items"
            (onSaved)="onSaved()"
        >
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-editing
                mode="batch"
                [allowUpdating]="true"
                [allowDeleting]="true"
                [allowAdding]="true"
                [selectTextOnEditStart]="true"
                newRowPosition="last"
            >
            </dxo-editing>
            <dxo-row-dragging
                [allowReordering]="true"
                [onReorder]="onReorder"
            ></dxo-row-dragging>
            <dxi-column
                dataField="itemNo"
                caption="No."
                dataType="number"
                [width]="80"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column
                dataField="description"
                caption="Description"
                [minWidth]="120"
            ></dxi-column>
            <dxi-column
                dataField="quantity"
                caption="Quantity"
                dataType="number"
                [width]="120"
            ></dxi-column>
            <dxi-column
                dataField="quantityName"
                caption="หน่วย (เว้นว่าง = ชิ้น)"
                [width]="160"
            ></dxi-column>
        </dx-data-grid>
    </div>
</div>
